import { useCallback, useState } from 'react';
import { ReportBugPopup } from './ReportBugPopup';
import { ShareFeedbackPopup } from './ShareFeedbackPopup';
import type { SiteFeedbackApi, SiteSupportCopy } from './types';

export function useSiteSupportPopups(api: SiteFeedbackApi, copy: SiteSupportCopy) {
  const [bugOpen, setBugOpen] = useState(false);
  const [feedbackOpen, setFeedbackOpen] = useState(false);

  const openBugReport = useCallback(() => setBugOpen(true), []);
  const openFeedback = useCallback(() => setFeedbackOpen(true), []);

  // Mount popups only while open. Keeping hidden dxPopup instances mounted caused
  // React #185 (max update depth) with React 19 + unstable popup option objects.
  const popups = (
    <>
      {bugOpen ? (
        <ReportBugPopup visible onClose={() => setBugOpen(false)} api={api} copy={copy} />
      ) : null}
      {feedbackOpen ? (
        <ShareFeedbackPopup visible onClose={() => setFeedbackOpen(false)} api={api} copy={copy} />
      ) : null}
    </>
  );

  return { openBugReport, openFeedback, popups };
}
